export default __webpack_public_path__ + "static/media/github_different.1e0e486e.png";